import axios from 'axios';

export default {
  selectors: (params = {}) => axios.get('expense-categories/selectors', { params }),
  store: (payload = {}) => axios.post('expense-categories', payload),
};
